<!--  -->
<template>
	<div class='login'>
		<div class='container'>
			<div class="login-left">
				<img src="../assets/img/login/logo.png" alt="">
			</div>
			<div class='login-right arrow-right' v-if="loginStatus">
				<div class="user-type">
					<button :class="user_type === 'user' ? 'active':''" @click="handleSelectType('user')">个人用户</button>
					<button :class="user_type === 'firm' ? 'active':''" @click="handleSelectType('firm')">企业用户</button>
				</div>
				<div class='top arrow-right-margin'>
					<p>
						<span class='lg-f13 lg-c34'>没有账号？</span><span class='lg-f13 lg-money palm' @click="loginStatus=false;Status=true">立即注册</span>
					</p>
					<p class='lg-f13 lg-money palm' @click="status=false" v-if="status">密码登录</p>
				</div>
				<div class='body-code arrow-right-margin' v-if="status">
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" @submit.native.prevent>
						<el-form-item prop="mobile">
							<el-input placeholder="请输入手机号" @input="change($event)" type="number" v-model="ruleForm.mobile"
							          autocomplete="off"></el-input>
						</el-form-item>
						<el-form-item prop="verify_code">
							<el-input placeholder="请输入验证码" @input="change($event)" type="number" maxlength="4" oninput="if(value.length > 4) value=value.slice(0, 4)" v-model="ruleForm.verify_code" autocomplete="off" />
							<button type="button" :disabled='codeStatus' class='code' @click="sendCode('ruleForm')">{{ codeText }}</button>
						</el-form-item>
						<div class='bottom arrow-right-margin'>
							<button class='log-in' @click="handleLogin('ruleForm')">立即登录</button>
						</div>
					</el-form>
				</div>
				<div class='body-password arrow-right-margin' v-else>
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" @submit.native.prevent>
						<el-form-item prop="mobile">
							<el-input placeholder="请输入手机号" @input="change($event)" type="number" v-model="ruleForm.mobile"
							     autocomplete="off"></el-input>
						</el-form-item>
						<el-form-item prop="password">
							<el-input placeholder="请输入密码" @input="change($event)" type="password" v-model="ruleForm.password"
							     show-password></el-input>
						</el-form-item>
						<p>
							<span class='lg-c34 lg-f14 palm' @click="loginStatus=false,regStatus=false">忘记密码</span><span
								class='lg-f14 lg-money palm' @click="status=true">验证码登录</span>
						</p>
						<div class='bottom arrow-right-margin'>
							<button class='log-in' @click="handleLogin('ruleForm')">立即登录</button>
						</div>
					</el-form>
				</div>
				<p class='agreement'>我已阅读和同意 <router-link target="_blank" :to="{name:'single_page',query:{id:getSettingConfig.getInfo('user_agreement')}}"><span>《用户协议》</span></router-link>和 <router-link target="_blank" :to="{name:'single_page',query:{id:getSettingConfig.getInfo('user_secret')}}"><span>《隐私政策》</span></router-link></p>
			</div>
			<div class='reg-right arrow-right' v-else>
				<div class="user-type">
					<button :class="user_type === 'user' ? 'active':''" @click="handleSelectType('user')">个人用户</button>
					<button :class="user_type === 'firm' ? 'active':''" @click="handleSelectType('firm')">企业用户</button>
				</div>
				<div class='top arrow-right-margin'>
					<p v-if="regStatus">
						<span class='lg-f13 lg-c34'>已有账号</span><span class='lg-f13 lg-money palm' @click="loginStatus=true">立即登录</span>
					</p>
					<p v-else>
						<span class="lg-f13 lg-money palm" @click="loginStatus=true">立即登录</span>
					</p>
				</div>
				<div class='body-code arrow-right-margin'>
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" @submit.native.prevent>
						<el-form-item prop="mobile">
							<el-input placeholder="请输入手机号" @input="change($event)" type="number" v-model.number="ruleForm.mobile"
							          autocomplete="off"></el-input>
						</el-form-item>
						<el-form-item prop="verify_code">
							<el-input placeholder="请输入验证码" @input="change($event)" type="number" v-model="ruleForm.verify_code"
							          autocomplete="off"></el-input>
							<button type="button" :disabled='codeStatus' class='code' @click="sendCode('ruleForm')">{{ codeText }}
							</button>
						</el-form-item>
						<el-form-item prop="password">
							<el-input placeholder="请输入密码" @input="change($event)" type="password" v-model="ruleForm.password"
							          show-password></el-input>
						</el-form-item>
						<div class='bottom arrow-right-margin'>
							<button class='log-in' v-if="regStatus" @click="handleReg('ruleForm')">立即注册</button>
							<button class='log-in' v-else @click="handleRest('ruleForm')">重置密码</button>
						</div>
					</el-form>
				</div>
				<p class='agreement'>我已阅读和同意 <router-link target="_blank" :to="{name:'single_page',query:{id:getSettingConfig.getInfo('user_agreement')}}"><span>《用户协议》</span></router-link>和 <router-link target="_blank" :to="{name:'single_page',query:{id:getSettingConfig.getInfo('user_secret')}}"><span>《隐私政策》</span></router-link></p>
			</div>
			<img src="../assets/img/login/close.png" alt="" class='close' @click="Close">
		</div>
		<el-dialog :title="content_title" :visible.sync="dialogAgreementVisible" width="40%" center>
			<div v-html="content_text"></div>
		</el-dialog>
	</div>
</template>

<script>

  import {mapMutations} from 'vuex';

  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
      //这里存放数据
      // 手机号码校验
      const validatorMobile = (rule, value, callback) => {
        if (value === null) {
          callback(new Error('请输入手机号'));
        } else {
          if (!(/^1[3456789]\d{9}$/.test(value))) {
            callback(new Error('手机号码格式错误'))
          }
          callback();
        }
      };
      // 密码校验
      const validatorPassword = (rule, value, callback) => {
        if (value === null) {
          callback(new Error('请输入密码'))
        } else if (value.length < 6) {
          callback(new Error('密码不能少于6位'))
        } else {
          if (!/^(?![^a-zA-Z]+$)(?!\D+$)/.test(value)) {
            callback(new Error('密码只能由数字和字母组成'))
          }
          callback();
        }
      };
      // 验证码校验
      const validatorCode = (rule, value, callback) => {
        if (value === null) {
          callback(new Error('请输入验证码'))
        }
        callback()
      }
      return {
        dialogAgreementVisible:false, // 弹框
        content_title:'', // dialog 标题
        user_type:"user",// 用户类型
        content_text:"", // 内容
        ruleForm: {
          mobile:null,
          verify_code:null,
          password:null,
        },
        rules: {
          mobile: [
            {validator: validatorMobile, trigger: 'blur'}
          ],
          verify_code: [
            {validator: validatorCode, trigger: 'blur'}
          ],
          password: [
            {validator: validatorPassword, trigger: 'blur'}
          ]
        },
        status: false, // 密码和验证码登录
        loginStatus: true, // 立即注册
        regStatus: true, //忘记密码
        codeText: "获取验证码", // 获取验证码文字
        codeStatus: false,
        num: 60
      };
    },
    //监控data中的数据变化
    watch: {
      status(newValue, oldValue) {
        this.$refs["ruleForm"].resetFields();
      },
      loginStatus(newValue, oldValue) {
        this.$refs["ruleForm"].resetFields();
      },
      regStatus(newValue, oldValue) {
        this.$refs["ruleForm"].resetFields();
      },
    },
    //方法集合
    methods: {
      ...mapMutations(['changeLogin']),
      Close() {
        this.$store.state.status.login = false
      },
      change() {
        this.$forceUpdate()
      },
      // 选中身份类型
      handleSelectType(data){
        this.user_type = data
        localStorage.setItem('type',data)
      },
      // 获取验证码
      sendCode(formName) {
        this.$refs[formName].validateField('mobile', (valid) => {
          if (!valid) {
            this.$requestApi.api.verify({
              mobile: this.ruleForm.mobile
            })
              .then(res => {
                if (res.success) {
                  this.codeStatus = true
                  const time = setInterval(() => {
                    this.num--
                    this.codeText = '已发送' + '(' + this.num + 's' + ')'
                    if (this.num === 0) {
                      this.codeText = '重新发送'
                      this.codeStatus = false
                      this.num = 60
                      clearInterval(time)
                    }
                  }, 1000)
                } else {
                  this.$message(res.message)
                }
              })
          }
        })
      },
      // 注册
      handleReg(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.user_type === 'firm') {
              this.$requestApi.api.firmReg(this.ruleForm)
                .then(res => {
                  const index = res.lastIndexOf('|')
                  const token = "Bearer" + ' ' + res.substring(index + 1, res.length)
                  this.changeLogin({Authorization: token})
                  let url = this.getSettingConfig.getInfo('app_url')+'/enterprise/personal?name=basic'
                  this.handleSaveInfo(url)
                  this.$store.state.status.login = false
                })
            } else {
              this.$requestApi.api.userReg(this.ruleForm)
                .then(res => {
                  const index = res.lastIndexOf('|')
                  const token = "Bearer" + ' ' + res.substring(index + 1, res.length)
                  this.changeLogin({Authorization: token})
                  this.handleSaveInfo()
                  this.$store.state.status.login = false
                })
            }
          }
        })
      },
      // 保存个人信息
      handleSaveInfo(url){
        if (this.user_type === 'firm') {
          this.$requestApi.api.firmInfo().then(res => {
            localStorage.setItem('user_info',JSON.stringify(res.data))
            window.location.href=url
            this.$store.state.status.message_count= res.data.notification_count
          })
            .catch(err =>{
              localStorage.removeItem("Authorization")
            })
        } else {
          this.$requestApi.api.userInfo().then(res => {
            localStorage.setItem('user-info',JSON.stringify(res.data))
            this.$store.state.status.message_count= res.data.notification_count
            this.$Bus.$emit('uploadInfo')
            if (!res.data.tags) {
              this.$Bus.$emit('interest_open')
            }
            if (res.data.attest_status === 0 || res.data.attest_status === 3) {
              this.$Bus.$emit('uploadInfo')
              this.$router.push({name:"personal",query:{name:'prove'}})
            } else if (res.data.tags) { location.reload() }
          })
            .catch(err =>{
              localStorage.removeItem("Authorization")
            })
        }
      },
      // 登录
      handleLogin(formName) {
        if (this.status) {   // 验证码登录
          delete this.ruleForm.password
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.user_type === 'firm' ? this.handleLoginFirm() : this.handleLoginUser()
            }
          })
        } else {  // 密码登录
          delete this.ruleForm.verify_code
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.user_type === 'firm' ? this.handleLoginFirm() : this.handleLoginUser()
            }
          })
        }
      },
      // 企业登录
      handleLoginFirm(){
        this.$requestApi.api.firmLogin(this.ruleForm)
          .then(res => {
            const index = res.lastIndexOf('|')
            const token = "Bearer" + ' ' + res.substring(index + 1, res.length)
            this.changeLogin({Authorization: token})
            this.$store.state.status.login = false
            let url = this.getSettingConfig.getInfo('app_url')+'/enterprise/'
            this.handleSaveInfo(url)
          })
      },
      // 个人登录
      handleLoginUser(){
        this.$requestApi.api.userLogin(this.ruleForm)
          .then(res => {
            const index = res.lastIndexOf('|')
            const token = "Bearer" + ' ' + res.substring(index + 1, res.length)
            localStorage.setItem('Authorization',token)
            this.changeLogin({Authorization: token})
            this.$store.state.status.login = false
            this.handleSaveInfo()
          })
      },
      // 忘记密码
      handleRest(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.user_type === 'firm') {
              this.$requestApi.api.firmReset(this.ruleForm).then(res => {
                 delete this.ruleForm.verify_code
                  this.handleLoginFirm()
                })
            } else {
              this.$requestApi.api.userReset(this.ruleForm).then(res => {
                delete this.ruleForm.verify_code
                  this.handleLoginUser()
                })
            }
          }
        })
      }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
      this.loginStatus = this.$store.state.status.loginStatus
      localStorage.setItem('type','user')
    },
  }
</script>
<style lang='less' scoped>
	.login {
		/deep/ .el-input__inner {
			height: 35px;
		}

		/deep/ .el-form-item__content {
			margin: 0 !important;
			display: flex;
			align-items: center;
			justify-content: space-between;
		}
		/deep/ .el-dialog{
			margin-top: 80px !important;
			.el-dialog__title{
				font-size: 14px;
				font-weight: bold;
			}
			.el-dialog__headerbtn:focus .el-dialog__close, .el-dialog__headerbtn:hover .el-dialog__close{
				color: #ffde00;
			}
			.el-dialog__body{
				height: 800px;
				overflow-y: scroll;
				padding-top: 0;
				*{
					font-size: 14px;
				}
			}
		}
	}

</style>

<style lang='less' scoped>
	.user-type{
		display: flex;
		margin-left: 30px;
		margin-top: 30px;
		button{
			padding:3px 5px;
			background: #FFFFFF;
			border: 1px solid #999999;
			/*margin-right: 15px;*/
			color: #999999;
			font-size: 12px;
		}
		button:first-child{
			border-right: 0;
			border-radius: 2px 0 0 2px;
		}
		button:last-child{
			border-left: 0;
			border-radius: 0 2px 2px 0;
		}
		.active{
			border: 1px solid #ffde00 !important;
			color: #ffde00;
		}
	}
	.login {
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		position: fixed;
		top: 0;
		left: 0;
		z-index:9999;
		.palm {
			cursor: pointer;
		}
		.container {
			display: flex;
			position: absolute;
			top: 50%;
			left: 50%;
			margin-top: -203px;
			margin-left: -370px;
			height: 400px;
			.login-left {
				width: 276px;
				height: auto;
				background-image: url('../assets/img/login/login.png');
				background-repeat: no-repeat;
				background-size: 100% 100%;
				img {
					width: 171px;
					height: 114px;
					margin: 21px auto 0;
				}
			}
			// 用户协议
			.agreement {
				width: 398px;
				margin: 0 auto;
				text-align: center;
				color: #666666;
				font-size: 12px;
				white-space: nowrap;
				position: absolute;
				bottom: 30px;
				span {
					color: #FF7C00;
					font-size: 12px;
					cursor: pointer;
				}
			}
			// 发送验证码
			.body-code {
				margin-top: 22px;
				.code {
					line-height: 35px;
					background-color: rgba(255, 214, 0, 1);
					border-radius: 4px;
					margin-left: 20px;
					font-size: 13px;
					display: block;
					white-space: nowrap;
					padding: 0 23px;
				}
			}
			// 登录
			.bottom {
				// 登录按钮
				.log-in {
					width: 100%;
					height: 35px;
					background-color: rgba(255, 214, 0, 1);
					border-radius: 4px;
					font-size: 13px;
				}
			}
			// 右上角关闭
			.close {
				width: 34px;
				height: 34px;
				position: absolute;
				right: -15px;
				top: -12px;
				cursor: pointer;
			}
			// 外边距
			.arrow-right{
				position: relative;
				.arrow-right-margin{
					margin-right: 30px;
					margin-left: 30px;
				}
			}
			// 登录
			.login-right {
				width: 398px;
				background-color: #FFFFFF;
				border-top-right-radius: 10px;
				border-bottom-right-radius: 10px;
				.palm {
					cursor: pointer;
				}
				.top {
					display: flex;
					justify-content: space-between;
					margin-top: 15px;
					p:first-child {
						span:first-child {
							margin-right: 16px;
						}
					}
				}
				.body-password {
					margin-top: 22px;
					p {
						display: flex;
						justify-content: space-between;
						margin-bottom: 27px;
					}
				}
			}

			// 注册
			.reg-right {
				width: 398px;
				background-color: #FFFFFF;
				border-top-right-radius: 10px;
				border-bottom-right-radius: 10px;
				.top {
					margin-top: 15px;
					p {
						span:first-child {
							margin-right: 16px;
						}
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/login.vue